import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { HIGH_GROWTH_VAULT_STRINGS } from "../HighGrowthVault/constants";
import { RSETH } from "@config/contractsConfig";
import { LSTIconMapping, toFixedWithoutRounding } from "@constants/common";
import React from "react";

import { useAccount } from "wagmi";

const TEXT_STRINGS = HIGH_GROWTH_VAULT_STRINGS.SECTIONS.PORTFOLIO.CLAIMS;

// amount : "0.0004" claimableTime : "~ in 9 days" date : Fri Nov 22 2024 05:30:00 GMT+0530 (India Standard Time) {} day : 22 index : 2 isClaimable : false key : "22-11-2024" month : 11 receiver : "0xA6ceEf881eF6Bf6d089FaCC5d55553c6328F3dBe" year : 2024

type VaultClaimsProps = {
  claims: any[];
};

const VaultClaims = ({ claims }: VaultClaimsProps) => {
  const { isConnected } = useAccount();

  return (
    <Flex direction={"column"}>
      {!isConnected && (
        <Text fontSize="12px" lineHeight="14.4px" fontWeight="400">
          {TEXT_STRINGS.walletConnect}
        </Text>
      )}

      {isConnected &&
        (claims.length > 0 ? (
          <Box overflowX={"auto"} w="100%">
            <Table variant="unstyled" p="0">
              <Thead>
                <Tr>
                  {TEXT_STRINGS.COLUMNS.map((col, idx) => {
                    return (
                      <Th
                        key={col + idx}
                        fontSize="12px"
                        lineHeight="14.4px"
                        fontWeight="400"
                        p={2}
                        textTransform="none"
                      >
                        {col}
                      </Th>
                    );
                  })}
                </Tr>
              </Thead>
              <Tbody>
                {claims.map((row: any, index: number) => (
                  <Tr key={index}>
                    <Td p={2}>
                      <Flex align="center" gap={2}>
                        <BaseImage
                          src={LSTIconMapping["rsETH"]}
                          width={12}
                          height={12}
                          alt="rseth"
                        />
                        <Text
                          fontSize="12px"
                          lineHeight="14.4px"
                          fontWeight="600"
                        >
                          {RSETH}
                        </Text>
                      </Flex>
                    </Td>
                    <Td
                      fontSize="12px"
                      lineHeight="14.4px"
                      fontWeight="600"
                      p={2}
                    >
                      {+toFixedWithoutRounding(row.amount, 6)}
                    </Td>
                    <Td p={2}>
                      {/* {row.isClaimable ? (
                          <Button
                            size="xs"
                            borderRadius="md"
                            bg="teal.700"
                            color="white"
                            _hover={{ bg: "teal.800" }}
                            onClick={() =>
                              emitReduxEvent(EVENTS.HANDLE_YIELD_VAULT_CLAIM, {
                                ...row,
                              })
                            }
                          >
                            Claim
                          </Button>
                        ) : (
                          <Text
                            fontSize="12px"
                            lineHeight="14.4px"
                            fontWeight="600"
                            color="#F28F57"
                          >
                            {row.claimableTime}
                          </Text>
                        )} */}

                      <Text
                        fontSize="12px"
                        lineHeight="14.4px"
                        fontWeight="600"
                        color="#F28F57"
                      >
                        {row?.isClaimable ? "Arriving soon" : row.claimableTime}
                      </Text>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        ) : (
          <Text fontSize="12px" lineHeight="14.4px" fontWeight="400" my="10px">
            {TEXT_STRINGS.noData}
          </Text>
        ))}
    </Flex>
  );
};

export default VaultClaims;
